import { Component, OnInit } from '@angular/core';
import { APICallingService } from '../model/APICallingService';
import { Store } from '@ngrx/store';
import { UserSettings } from '../model/UserSettings';
import { AppSettings, IAppSettings } from '../model/application-settings';
import { createOfflineCompileUrlResolver } from '@angular/compiler';
import { Router } from '@angular/router';

@Component({
  selector: 'app-myorders',
  templateUrl: './myorders.component.html',
  styleUrls: ['./myorders.component.css']
})
export class MyordersComponent implements OnInit {

  dbResult:any;
  lstOrders:any = [];
  storeUserSettings:any;
  showDetails:boolean  = false;
  showDetailsoutofdelivery:boolean = false;
  showDetailsinprogress:boolean = false;
  showDetailscancelled:boolean = false;
  imagePath = 'http://localhost/ApplicationLevelScripts/';

  constructor(private router:Router,private apiCall:APICallingService,private store: Store<any>,private storeAppSettings:AppSettings,) { }

  storeSettings:IAppSettings=
  {
      faxUserId:'',
      faxPassword:'',
      companyName:'',
      theamColorCode:'#ea0029',
      headerColorCode: '#000',
      headerimage: '../../assets/img/trending1.png',
      loginBackgroundImage:'../../assets/img/logo_web.png',
      loginImage:'../../assets/img/logo_web.png',
      dangerColorCode: '#dc3545',
      successColorCode: '#28a745',
      logo: '../../assets/img/logo_web.png',
      paymentGateway:'',
      key:'',
      selectedBranch:'',
      apiLoginId:'',
      orderEmail:'',
      adminUrl:'',
      orderUrl:'',
      viewName:'AppSettings',
      apiCallingUrl:'',
      fontFamily:'prompt,sans-serif',
      domainName:'',
      fax:'',
      projectId:'',
      keyNo:'',
      noOfBranches:0,
      addClover:'',
      cloverAccessToken:'',
      cloverAuthToken:'',
      cloverMerchantId:'',
      cloverEmployeeID:'',
      cloverTenderId:'',
      currency:'',
      transactionkey:'',
  };
  homeClick()
  {
    this.router.navigateByUrl('/')
  }
  ngOnInit(): void {
    debugger;
    this.storeUserSettings= new UserSettings();
    var result = (this.store as any).source['value']['MSFOO'].filter((x:any) => { return x.viewName == "UserDetails"; });
    if (result.length > 0) {
      this.storeUserSettings=( Object.assign({},result[0] ));
    }
    this.storeSettings= this.storeAppSettings.loadSettings();
    this.viewMyOrders();
  }

  tempOrders:any=[];
  
  viewMyOrders(){
    debugger;
    this.apiCall.DBCalling("MyDeliveries",this.storeUserSettings.UserID,"","","").subscribe(
      (res:any) => {
        debugger;
        this.dbResult= (res);
        this.lstOrders = (Object.assign([],this.dbResult.tasks[0]));
        this.tempOrders = (Object.assign([],this.dbResult.tasks[0]));
        debugger;
        for(let i=0;i<this.lstOrders.length;i++){
          if(this.lstOrders[i].DeliveryDetails != null){
          let data = this.lstOrders[i].DeliveryDetails;
          var resData=((data).replace(/\n/g, "")).replace(/'/g,"\"");
          this.lstOrders[i].DeliveryDetails=JSON.parse(resData);
          }else{
            this.lstOrders[i].DeliveryDetails = Object.assign([{}],{Addons:'',Date: "",DeliveryScheduleID: "",ID: "",ProductCode: "",ProductID: "",ProductImage: "",ProductName:"",Qty:"",Rating:"",
            ServiceName:"",Toppings:""})
          }
        }
    });
  }

  completedtabdisplay = 'none';
  currentPage='On Progress';
  delivered(){
    this.currentPage='Completed';
    debugger;
    this.showDetails = false;
    this.showDetailsoutofdelivery = false;
    this.showDetailsinprogress = false;
    this.showDetailscancelled = false;
    var status = this.tempOrders.filter((x: { Status: string; })=>x.Status === 'Delivered' || x.Status === 'Picked');
    this.lstOrders = status;
    this.completedtabdisplay = 'block';
    this.outofdeliverytabdisplay = 'none';
    this.inprogresstabdisplay = 'none';
    this.canceledtabdisplay = 'none';
  }
  // currentPage='Completed'
  outofdeliverytabdisplay = 'none';
  outofdeliver(){
    debugger;
    this.currentPage='Out Of Delivery'
    // if(this.showDetailsoutofdelivery == true || this.showDetailsinprogress == true || this.showDetailscancelled == true){
    //     window.location.reload();
    // }
    this.showDetails = false;
    this.showDetailsoutofdelivery = false;
    this.showDetailsinprogress = false;
    this.showDetailscancelled = false;
    var status = this.tempOrders.filter((x: { Status: string; })=>x.Status === 'Assigned' || x.Status === 'In Route');
    // if(status.length == 0){
    // var status = this.tempOrders.filter((x: { Status: string; })=>x.Status === 'In Route');
    // }
    this.lstOrders = status;
    this.completedtabdisplay = 'none';
    this.outofdeliverytabdisplay = 'block';
  }

  inprogresstabdisplay = 'block';
  progress(){
    debugger;
    this.currentPage='On Progress';
    // if(this.showDetailsoutofdelivery == true || this.showDetailsinprogress == true || this.showDetailscancelled == true){
    //   window.location.reload();
    //  }
    this.showDetails = false;
    this.showDetailsoutofdelivery = false;
    this.showDetailsinprogress = false;
    this.showDetailscancelled = false;
    var status = this.tempOrders.filter((x: { Status: string; })=>x.Status === 'Open');
    this.lstOrders = status;
    this.completedtabdisplay = 'none';
    this.outofdeliverytabdisplay = 'none';
    this.inprogresstabdisplay = 'block';
  }

  canceledtabdisplay = 'none';
  cancel(){
    debugger;
    this.currentPage='Canceled';
    // if(this.showDetailsoutofdelivery == true || this.showDetailsinprogress == true || this.showDetailscancelled == true){
    //   window.location.reload();
    //  }
    this.showDetails = false;
    this.showDetailsoutofdelivery = false;
    this.showDetailsinprogress = false;
    this.showDetailscancelled = false;
    var status = this.tempOrders.filter((x: { Status: string; })=>x.Status === 'Canceled');
    this.lstOrders = status;
    this.completedtabdisplay = 'none';
    this.outofdeliverytabdisplay = 'none';
    this.inprogresstabdisplay = 'none';
    this.canceledtabdisplay = 'block';
  }

  OrderNetTotal:string="";
  DeliveryAddress:string="";
  Date:string="";
  Status:string="";
  showItemDetails(y:any,d:any){
    debugger;
    if(y == 1){
      this.showDetails = true;
      this.Date = d.Date;
      this.DeliveryAddress = d.DeliveryAddress;
      this.OrderNetTotal = d.OrderNetTotal;
      this.Status = d.Status;
    }else{
      this.showDetails = false;
    }
  }

  totalAmount:string="";
  DeliverAddress:string="";
  DateofDeliver:string="";
  StatusDeliver:string="";
  showoutofDeliveryDetails(d:any,a:any){
    debugger;
    if(d == 1){
      this.showDetailsoutofdelivery = true;
      this.DateofDeliver = a.Date;
      this.DeliverAddress = a.DeliveryAddress;
      this.totalAmount = a.OrderNetTotal;
      this.StatusDeliver = a.Status;
    }else{
      this.showDetailsoutofdelivery = false;
    }
  }
  
  progressAmount:string="";
  progressAddress:string="";
  progressDate:string="";
  progressStatus:string="";
  showinprogressDetails(e:any,b:any){
    debugger;
    if(e == 1){
      this.showDetailsinprogress = true;
      this.progressDate = b.Date;
      this.progressAddress = b.DeliveryAddress;
      this.progressAmount = b.OrderNetTotal;
      this.progressStatus = b.Status;
    }
    else{
      this.showDetailsinprogress = false;
    }
  }

  cancelDate:string="";
  cancelAddress:string="";
  cancelAmount:string="";
  cancelStatus:string="";
  CancelledViewDetails(x:any,c:any){
    debugger;
    if(x == 1){
      this.showDetailscancelled = true;
      this.cancelDate = c.Date;
      this.cancelAddress = c.DeliveryAddress;
      this.cancelAmount = c.OrderNetTotal;
      this.cancelStatus = c.Status;
    }else{
      this.showDetailscancelled = false;
    }
  }

  // showMap = false;
  // showorders = true;
  // mapdetails(d:any){
  //   if(d==1){
  //   this.showorders = false;
  //   this.showMap = true;
  //   }else{
  //     this.showorders = true;
  //     this.showMap = false;
  //   }
  // }
}